(function(){
'use strict';
if(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)return;
if(window.navigator&&window.navigator.standalone)return;
var ua=navigator.userAgent||'';
var ios=/iphone|ipad|ipod/i.test(ua);
var android=/android/i.test(ua);
function ready(){return !!(window.SweetDealsPWA&&window.SweetDealsPWA.deferredPrompt)}
function help(){
  if(ios){alert('Install Sweet Deals App:\n\n1. Open this store in Safari.\n2. Tap Share.\n3. Tap Add to Home Screen.\n4. Tap Add.');return}
  if(android){alert('Install Sweet Deals App:\n\nIf the install box does not open, open Chrome menu and tap Install app or Add to Home screen.');return}
  alert('Install Sweet Deals App:\n\nIf the install box does not open, use your browser install icon or menu and choose Install app.')
}
document.addEventListener('click',function(e){
  var t=e.target.closest('.sdw-pwa-install-action,a[href*="#install-app"]');
  if(!t)return;
  e.preventDefault();
  e.stopPropagation();
  if(window.SweetDealsPWA&&typeof window.SweetDealsPWA.promptInstall==='function'&&ready()){
    window.SweetDealsPWA.promptInstall().then(function(ok){if(!ok)help()}).catch(help);
  }else{help()}
},true);
})();